import { logger } from "@/utils/logger";
import { getProcess } from './../../services/task/actions/uploadDocumentService';
import {Module} from "vuex";
import {
    InventoryStatusEnum,
    Order,
    OrderAssetComponent,
    OrderAssetDelivery,
    OrderAssociatedParty,
    OrderItem,
    OrderModeStatus,
    OrderNetwork,
    OrderNetworkNode,
    OrderParty,
    OrderPartyRoleEnum,
    OrderState,
    OrderStatusEnum,
    OrderVehicle, Task, TaskModule
} from "@/types";
import {calculateProposalAsset, getAssetProduct} from "@/store/services/asset/assetMapper";
import {deepClone, sleep} from "@/utils";
import store from "@/store";
import {
    getAssetCustom,
    getassetTax,
    getCommercial,
    getNetwork,
    getNetworkNode,
    getPartyUser
} from "@/store/services/offerService";
import {convertAssetDeliveryModel, convertOrderVehicleToProductVehicle, convertProductAssetToOrderAsset, getOrderAssetServices, initOrders} from "@/store/services/order/orderMapper";
import {formatDate} from "@/utils/configuration/formatters-config";
import {createOrderAlert, createProductCategoryClass, deleteOrder, deleteOrderAlert, getInventoryItem, getOrder, getOrderItem, searchOrder, updateInventoryItem, updateOrderAlert, updateOrderItem, updateOrderStatus} from "@/store/services/order/orderApi";
import {
    buildAlertList,
    buildOrderAlert,
    getAlertReasons,
    getOrderAlertList,
    getOrderEditMode,
    getOrderParties,
    getOrderTaskHistory,
    getPlaningEvent,
    initOrderWorkflow,
    orderDuplicateMode,
    saveOrder,
    searchAssetOrder
} from "@/store/services/order/orderService";
import Notify from 'quasar/src/plugins/Notify.js';;
import i18n from "@/i18n";
import router from "@/router";
import { getAdditionalInformation } from '@/store/services/picklist';
import orderFinancingModule from "@/store/modules/order/financing/orderFinancingModule";
import { getProductFeature } from '@/store/services/financing/product';
import { getGoodProposalItem, selectGoodImage } from '@/store/services/configuration/AssetService';
import moment from 'moment';


const orderModule: Module<OrderState, any> = {
    namespaced: true,
    state: {
        mode: OrderModeStatus.CREATE,
        showAlert:false,
        index: -1,
        orders: [],
        order: {},
        orderItem: {},
        preConditionDetailVisible :false,
        orderFinancingModule: {
            financing: {},
        },
        selectedAssetFrom:{},
        selectedProductAsset:{},
        tempSelectedOrderGoods: {},
        tempGoodOrderFilter: {},
        goodOrderFilter: {},
        selectedEventPlanning:{
            title: '',
            actionStartDate:'',
            actionStartHour:'',
            actionEndDate:'',
            actionEndHour:'',
            comment:'',
            clientName:'',
            range:'',
            brand:'',
            assetProduct:'',
            description:'',
            status_code:''
        },
        alertList: [],
        selectedSearchOrder: {}
    },
    getters: {
        getMode(state) {
            return state.mode
        },
        isModeCreate(state) {
            return state.mode === OrderModeStatus.CREATE
        },
        isModeEdit(state) {
            return state.mode === OrderModeStatus.EDIT
        },
        getOderInit(): Order {
            return {
                reference: '',
                channel: '',
                previsionDeliveryDate: '',
                effectiveDeliveryDate: '',
                assignedSalesPerson: '',
                orderParties: [store.getters["orderModule/getOrderAssociatedPartyInit"]],
                orderNetworks: store.getters["orderModule/getOrderNetworkInit"],
                orderNetworkNodes: store.getters["orderModule/getOrderNetworkNodeInit"],
                status: {
                    resourceUid: OrderStatusEnum.ORDER,
                    objectType: 'odm.order.orderstatus'
                },
                orderItems: [store.getters["orderModule/getOrderItemInit"]],
                objectType: 'odm.order.order',
                systemUid: 'odm-order',
                alertList: [],
                orderSubvention: [],
            }
        },
        getOrderAssociatedPartyInit(): OrderAssociatedParty {
            return {
                orderParty: store.getters["orderModule/getOrderPartyInit"],
                objectType: 'odm.order.orderassociatedparty',
                systemUid: 'odm-order',
            }
        },
        getOrderNetworkInit(): OrderNetwork {
            return {
                network: {
                    objectType: 'odm.party.network',
                    systemUid: 'odm-party',
                },
                objectType: 'odm.order.ordernetwork',
                systemUid: 'odm-order',
            }
        },
        getOrderNetworkNodeInit(): OrderNetworkNode {
            return {
                networkNode: {
                    objectType: 'odm.party.networknode',
                    systemUid: 'odm-party',
                },
                objectType: 'odm.order.ordernetworknode',
                systemUid: 'odm-order',
            }
        },
        getOrderItemInit(): OrderItem {
            return {
                reference: '',
                externalReference: '',
                initialDeliveryDate: '',
                previsionDeliveryDate: '',
                effectiveDeliveryDate: '',
                orderItemParent: null,
                type: {
                    objectType: 'odm.order.orderitemtype',
                    systemUid: 'odm-order',
                    resourceUid: 'CUSTOMER'
                //     TODO verify
                },
                status: {
                    objectType: 'odm.order.orderitemstatus',
                    systemUid: 'odm-order',
                },
                orderAssets: [store.getters["orderModule/getOrderAssetInit"],store.getters["orderModule/getOrderAssetInit"]],
                objectType: 'odm.order.orderitem',
                systemUid: 'odm-order',
            }
        },
        getOrderPartyInit(): OrderParty {
            return {
                party: {
                    objectType: 'odm.party.party.organization.frenchperson',
                    systemUid: 'odm-party',
                },
                role: {
                    resourceUid: OrderPartyRoleEnum.CUSTOMER,
                    objectType: 'odm.order.orderpartyrole'
                },
                objectType: 'odm.order.orderparty',
                systemUid: 'odm-order',
            }
        },
        getAssetTradeInInit(): any {
            return {
                overEstimationAmount: {
                  amount: 0.0,
                  currency: 'EUR'
                },
                conversionBonus:{
                  amount: 0.0,
                  currency: 'EUR'
                },
                origin: '',
                objectType: 'odm.order.orderassettradein',
                systemUid: 'odm-order',
              }
        },

        getOrderAssetInit(): OrderVehicle {
            return {
                description: '',
                amountWoTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                discountPercentage: 0,
                discountAmount: {
                    amount: 0,
                    currency: 'EUR'
                },
                taxAmount: {
                    amount: 0,
                    currency: 'EUR'
                },
                amountWTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                quantity: 0,
                totalAmountWoTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                totalTaxAmount: {
                    amount: 0,
                    currency: 'EUR'
                },
                totalAmountWTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                purchaseAmountWoTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                purchaseAmountWTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                assetProduct: undefined,
                packAssetProduct: undefined,
                assetTradeIn:store.getters["orderModule/getAssetTradeInInit"] ,
                supplier: store.getters["orderModule/getOrderPartyInit"],
                orderAssetComponents: [],
                orderAssetServices: [store.getters["orderModule/getOrderAssetServiceInit"]],
                assetDelivery: store.getters["orderModule/getOrderAssetDeliveryInit"],
                objectType: 'odm.order.orderasset.ordergood.ordervehicle.ordercar',
                systemUid: 'odm-order',
                flagNew: true,
                nbOfCylinder: 0,
                nbOfGear: 0,
                taxHorsePower: 0,
                horsePower: 0,
                co2Emissions: 0,
                mineType: 0,
                fuelConsumptionUrban: 0,
                fuelConsumptionExtraUrban: 0,
                fuelConsumptionCombined: 0,
                brand: '',
                range: '',
                version: '',
                carBodyStyle: '',
                gearBox: '',
                engineType: '',
                matriculation: '',
                matriculationDate: '',
                chassisReference: '',
                constructionDate: '',
                currentMileage: 0,
                vehicleLength: '',
                color: '',
                firstCarRegistrationDate: '',
                insideColor: '',
            }
        },
       
        getOrderAssetComponentInit(): any {
            return {
                config: {
                    required: false,
                    selected: true,
                    selectModel: {
                      label: "",
                      id: "",
                    },
                    unitaryAmountModel: 0,
                    amountWithTaxModel: 0,
                    taxValueModel: {
                      label: "",
                      id: "",
                    },
                    purchaseAmountWTaxModel: 0,
                    purchaseAmountWoTaxModel: 0,
                    reference: undefined,
                  },
                type: {
                    objectType: 'odm.order.orderassetcomponenttype',
                    systemUid: 'odm-order',
                },
                label: '',
                amountWTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                discountPercentage: 0,
                discountAmount: {
                    amount: 0,
                    currency: 'EUR'
                },
                taxAmount: {
                    amount: 0,
                    currency: 'EUR'
                },
                amountWoTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                quantity: 1,
                totalAmountWoTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                totalTaxAmount: {
                    amount: 0,
                    currency: 'EUR'
                },
                totalAmountWTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                objectType: 'odm.order.orderassetcomponent',
                systemUid: 'odm-order',
            }
        },
        getOrderAssetServiceInit(): any {
            return {
                type: {
                    objectType: 'odm.order.orderassetservicetype',
                    systemUid: 'odm-order',
                },
                label: '',
                purchase: "false",
                duration: 0,
                mileage: 0,
                activatedContract: false,
                amountWTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                amountWoTax: {
                    amount: 0,
                    currency: 'EUR'
                },
                commissionAmount: {
                    amount: 0,
                    currency: 'EUR'
                },
                objectType: 'odm.order.orderassetservice',
                systemUid: 'odm-order',
            }
        },
        getOrderAssetDeliveryInit(): OrderAssetDelivery {
            return {
                deliveryDate: '',
                initialDeliveryDate:'',
                previsionDeliveryDate:'',
                effectiveDeliveryDate:'',
                deliveryAddress: {
                    objectType: '',
                    systemUid: '',
                },
                description: '',
                objectType: 'odm.order.orderdeliverydetails',
                systemUid: 'odm-order',
            }
        },
        getSelectedAssetFromInit() {
            return {}
        },
        getSlectedProductAssetInit() {
            return {}
        },
        getOrderReference(state){
            return state.order?.reference;
        },
        getInitSelectedEventPlanning(){
         return  {
            title: '',
            actionStartDate:'',
            actionStartHour:'',
            actionEndDate:'',
            actionEndHour:'',
            comment:''
          }
        }
    },
    actions: {
        async initOrderEditMode({ commit}, payload) {
            const { resourceUid } = payload
            if (!resourceUid) {
                throw new Error('ResourceUid is mandatory!')
            }
            this.dispatch('taskModule/setModule', { module: TaskModule.ORDER })
            try {
                const order = await getOrderEditMode(resourceUid)
                commit('setOrder', order)
                const orderParties = await getOrderParties(order.orderParties)
                this.dispatch('orderPartyModule/setOrderParties', { orderParties: orderParties})
                //const {orderItems} = order
                const orderItems =await initOrders(order.orderItems)
                commit('setOrders', orderItems || [])
                const assetDeliveryModel = await convertAssetDeliveryModel(orderItems,order)
                commit('setAssetDeliveryModel', assetDeliveryModel)
                /*for(const orderItemState of orderItems ){
                    const orderAssets =  orderItemState.orderAssets[0]
                    commit('setOrderItem', orderItemState)
                    commit('setAsset', orderAssets)
                }*/
                //get orderItems 
                /*store.dispatch("orderModule/initOrderItem", {
                    index: 0, orderItem: orderItems[0]
                  })*/
               // await this.dispatch("orderModule/editOrderItem")  
                store.dispatch("commandModule/setMode", "edit");
            //     TODO EF-202 review
                this.dispatch('printDocumentModule/toggleShowButton')
            } catch (e) {
                Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
                    message: 'ERROR: ' + e,
                    color: 'negative'
                })
            }
        },
        toggleShow({ commit }) {
            commit('toggleShow')
        },
        deleteOrder({ commit }, payload) {
            const { resourceUid } = payload
            deleteOrder(resourceUid)
                .then((res:any) => {
                    Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
                        message: i18n.global.t("order.messages.deleteSuccess"),
                        color: "positive",
                    })
                    
                })
                .catch((err:any) => {
                    logger.error(err);
                    Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
                      message: err.message || err.error || err,
                      color: "negative",
                    });
                })
        },
        async orderDuplicateMode({ commit}, payload) {
            const { resourceUid ,number,length,callback} = payload
            if (!resourceUid) {
                throw new Error('ResourceUid is mandatory!')
            }
            this.dispatch('taskModule/setModule', { module: TaskModule.ORDER })
            try {
                const order = await orderDuplicateMode(resourceUid,number,length)
				if (callback) {
                    callback(order)
                }

            } catch (e) {
                Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
                    message: 'ERROR: ' + e,
                    color: 'negative'
                })
            }
        },
		
        initOrder({ commit,  getters }, payload) {
            const order = getters.getOderInit
            order.effectiveDeliveryDate = formatDate(new Date(), "/")
            this.dispatch('taskModule/setModule', { module: TaskModule.ORDER })
            commit('setOrder', order)
        },
        async initOrderItem({ commit, getters,state }, payload) {
            const { index, orderItem } = payload
            commit('setIndex', index)
            const isCreateMode = !orderItem
            const orderItemState: OrderItem = deepClone(isCreateMode ? getters.getOrderItemInit : orderItem)
            if (isCreateMode) {
                orderItemState.effectiveDeliveryDate = formatDate(new Date(), "/")
            }
            commit('setMode', isCreateMode ? OrderModeStatus.CREATE : OrderModeStatus.EDIT)
            if (!orderItemState || !orderItemState.orderAssets?.length || !(payload.index > -1)) {
                throw new Error('Invalid state initialization')
            }
            const orderAssets =  orderItemState.orderAssets[0]
            const asset= await convertOrderVehicleToProductVehicle(orderAssets)
            logger.debug(asset)
            orderItemState.orderAssets[0].config=asset.config
            orderItemState.orderAssets[0].proposalAssetItems=asset.proposalAssetItems
            commit('setOrderItem', orderItemState)
            commit('setAsset', asset)
            const newOrders: any = deepClone(state.orders)

            newOrders.push(orderItemState)
            commit('setOrders', newOrders)
        },
        async initOrderWorkflow({ state}, payload) {
            const { order } = state
            const { callback } = payload || {}
            try {
                await initOrderWorkflow(order)
                this.dispatch('taskModule/getFutureTaskByReferenceAndTaskDefinition', {
                    orderReference: order.reference,
                    taskDefinition: undefined,
                    onSuccess: async (task: Task) => {
                        await this.dispatch('taskModule/setModule', { module: TaskModule.ORDER })
                        await this.dispatch('releaseLockState')
                        await this.dispatch('taskModule/claimOwnership', { task, callback,blockRedirection: false })
                        
                    },
                    onFail: async () => {
                        await this.dispatch('releaseLockState')
                        await this.dispatch('taskModule/getTasks')
                        if (callback) callback()
                        await router.push("/task/list");
                    }
                })
            } catch (e: any) {
                Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
                    message:  e.message || e,
                    color: "negative",
                })
            }
        },
         saveOrder({ state, dispatch }, payload) {
            const { order, orders } = state
            const {orderParties} =payload
            order.orderItems = orders
            if (!order.reference || order.reference === '') {
                order.reference = 'TS' + (Math.random() + 1).toString().substring(2,8)
            }

             saveOrder(state.order,orderParties)
                .then((res: any) => {
                    if (payload && payload.callback) {
                        payload.callback(res)
                    }
                    Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
                        message: i18n.global.t("order.messages.createSuccess"),
                        color: "positive",
                    })
                    dispatch('initOrderEditMode', {
                        resourceUid: res.resourceUid
                    })
                })
                .catch(e => {
                    order.reference = ''
                    Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
                        message: 'ERROR: ' + e,
                        color: 'negative'
                    });
                })
        },
        async fetchUser() {
            return getPartyUser();
        },
        network({ commit }, payload) {
            const { filter, callback } = payload
            getNetwork(filter)
                .then(res => {
                    if (res.items.length == 1) {
                        commit('setNetwork', res.items[0]);
                    }
                    callback(res);
                })
                .catch(e => logger.error(e))
        },
        searchAssetOrder({ commit }, payload) {
            const { filter, callback } = payload
            searchAssetOrder(filter)
                .then(res => {
                    
                    callback(res);
                })
                .catch(e => logger.error(e))
        },
        async getPlaningEvent({ commit }, payload) {
            const { callback,filter } = payload
            const res = await getPlaningEvent(filter)
            logger.debug(res)
            commit('setPlaningEvent', res);
            callback(res);
     
        },
        setPlaningEvent({ commit }, payload) {
            commit('setPlaningEvent', payload);
        },
        selectedDayEvent({ commit }, payload) {
          
            commit('selectedDayEvent', payload);     
        },
        changeDateEvent({ commit }, payload) {
          
            commit('changeDateEvent', payload);     
        },
       
        initSelectedEventPlanning({ commit,  getters }) {
            const selectedEventPlanning = getters.getInitSelectedEventPlanning
            commit('setSelectedEventPlanning', selectedEventPlanning)
        },
        setSelectedEventPlanning({ commit},  payload ) {
             commit('setSelectedEventPlanning', payload)
        },
        commercial({ commit }, payload) {
            const { filter, callback } = payload
            getCommercial(filter)
                .then(res => {
                    if (res.items.length == 1) {
                        commit('setCommercial', res.items[0]);
                    }
                    callback(res);
                })
                .catch(e => logger.error(e))
        },
        networkNode({ commit }, payload) {
            const { filter, callback } = payload
            getNetworkNode(filter)
                .then(res => {
                    if (res.items.length == 1) {
                        commit('setNetworkNode', res.items[0]);
                    }
                    callback(res);
                })
                .catch(e => logger.error(e))
        },
        setOrderAssociatedParty({ commit }, payload) {
            commit('setOrderAssociatedParty', payload)
        },
        setChannel({ commit }, payload) {
            commit('setChannel', payload)
        },
        setSupplier({ commit }, payload) {
            commit('setSupplier', payload)
        },
       async createOrderAlert({ state, commit }, payload) {
        const { orderId,comment, reasons } = payload
           const orderAlert = await  buildOrderAlert(comment,reasons)
             if (orderAlert){
                   const  createdAled=await createOrderAlert(orderAlert,orderId)
                   logger.debug(createdAled)
                   await sleep(250)
                    const filter={
                        orderId : orderId
                        }
                    const list= await getOrderAlertList(filter)
                    const alertList=  buildAlertList(list)
                    Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
                                message: "Order Alert created...",
                                color: "positive",
                            })

                    commit('setOrderAlertList',alertList)
             }
          },
          updateOrderAlert({ state, commit }, payload) {
            const { alertId,comment, reasons} = payload
                    updateOrderAlert(reasons,alertId)
                    .then(res => {
                        Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
                            message: "Order Alert updated...",
                            color: "positive",
                        })
                    })
                    .catch(e => logger.error(e))
              },
         async deleteOrderAlert({ state, commit }, payload) {
                const {orderId ,alertId} = payload
                      const item = await  deleteOrderAlert(alertId)
                      
                      await sleep(250)
                            const filter={
                                orderId:orderId
                                }
                          const list= await getOrderAlertList(filter)
                    
                           const alertList=  buildAlertList(list)
                           
                            Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
                                message: "Order Alert deleted...",
                                color: "positive",
                            })

                            commit('setOrderAlertList',alertList)
               
            },
          setorderSubvention({ state, commit }, payload) {
            if (state.order?.orderSubvention) {
              const oldorderSubventiont = state.order.orderSubvention;
              oldorderSubventiont.push(payload);
              commit("setorderSubvention", oldorderSubventiont);
            } else {
              commit("setorderSubvention", [payload]);
            }
          },
        async insertOrderItem({ state, commit }) {
            const { orderItem, asset,order } = state
            const orderAssetServices = getOrderAssetServices(orderItem.orderAssets[0].orderAssetServices)
            orderItem.orderAssets[0] = convertProductAssetToOrderAsset(asset,orderItem)
            orderItem.orderAssets[0].orderAssetServices=orderAssetServices
            store.state.orderModule.tempSelectedOrderGoods && store.state.orderModule.tempSelectedOrderGoods.inventory_item_code 
            ? orderItem.orderAssets[0].inventoryItemCode= store.state.orderModule.tempSelectedOrderGoods.inventory_item_code 
            : null
            const newOrders: any = deepClone(state.orders)
            newOrders.push(orderItem)
            commit('setOrders', newOrders)

            const assetDeliveryModel = await convertAssetDeliveryModel(newOrders,order)
            commit('setAssetDeliveryModel', assetDeliveryModel)
        },
        async editOrderItem({ state, commit }) {
            const { index, orderItem, asset,order } = state
            const newOrders: any = deepClone(state.orders)
            const orderAssetServices = getOrderAssetServices(orderItem.orderAssets[0].orderAssetServices)
            orderItem.orderAssets[0] = convertProductAssetToOrderAsset(asset,orderItem)
            orderItem.orderAssets[0].orderAssetServices=orderAssetServices
            newOrders[index] = orderItem
            commit('setOrders', newOrders)

            const assetDeliveryModel = await convertAssetDeliveryModel(newOrders,order)
            commit('setAssetDeliveryModel', assetDeliveryModel)
        },
        deleteOrderItem({ state, commit }, payload) {
            const {index, inventoryItemCode} = payload
            const orderToRemove = state.orders[index]
            if (inventoryItemCode){
                this.dispatch("orderModule/updateInventoryItem",{
                    inventoryItemCode: inventoryItemCode,
                    status: InventoryStatusEnum.IN_STOCK
                })
            }
            const newOrders: any = deepClone(state.orders.filter((order: any) => order !== orderToRemove))
            commit('setOrders', newOrders)
        },
        searchAsset({ commit, state }, payload) {
            const { id, category, refreshAssetItems,index,productName} = payload
            const { orders,order } = state
            const proposalAsset = state.orders[index].orderAssets[0]
            const assetDeliveryModel = deepClone(proposalAsset.config.assetDeliveryModel)
            const supplier = deepClone(proposalAsset.config.formBind.supplier)
            if (id && proposalAsset) {
                getAssetProduct(id, proposalAsset, category, refreshAssetItems).then(async res => {
                    res.config.assetDeliveryModel = assetDeliveryModel
                    res.config.formBind.supplier = supplier
                    res.config.supplierPartyName= supplier.name
                    commit("setAsset", res)
                    const orderAssetServices = getOrderAssetServices(orders[index].orderAssets[0].orderAssetServices)
                    orders[index].orderAssets[0] = convertProductAssetToOrderAsset(res,orders[index])
                    orders[index].orderAssets[0].orderAssetServices=orderAssetServices
                    orders[index].orderAssets[0].config.assetDeliveryModel = assetDeliveryModel
                    orders[index].orderAssets[0].config.formBind.supplier = supplier
                    orders[index].orderAssets[0].config.supplierPartyName= supplier.name
                    if(productName){                 
                    orders[index].orderAssets[0].description=productName
                    }
                    store.state.orderModule.tempSelectedOrderGoods && store.state.orderModule.tempSelectedOrderGoods.inventory_item_code 
                    ? orders[index].orderAssets[0].inventoryItemCode= store.state.orderModule.tempSelectedOrderGoods.inventory_item_code 
                    : null
                    logger.debug(orders)
                    commit('setOrders', orders)

                    const assetDeliveryModelNew = await convertAssetDeliveryModel(orders,order)
                    commit('setAssetDeliveryModel', assetDeliveryModelNew)
                    logger.debug("newOrders")
                    if (payload.callback) {
                        payload.callback(res)
                    }
                }).catch((e: any) => {
                    logger.error(e)
                })   
            }
        },
        getAdditionalInformation({ commit }, payload) {
            const { filter, callback } = payload
            getAdditionalInformation(filter)
                .then(res => {
                    callback(res);
                })
                .catch(e => logger.error(e))
        },
        addNewProposalAssetItem({state, commit }, payload) {
            const { type, index } = payload
            const proposalAsset = state.orders[index].orderAssets[0]
            const orderAssetComponent = deepClone(store.getters["orderModule/getOrderAssetComponentInit"])
            orderAssetComponent.config.reference = (Math.random() + 1).toString(36).substring(7)
            orderAssetComponent.type = type
            proposalAsset.orderAssetComponents.push(orderAssetComponent)
            logger.debug('addNewProposalAssetItem')
            commit('setProposalAssetByIndex', { proposalAsset, index })
            commit('setOrders', state.orders)
        },
        updateProposalAssetItem({ commit }, payload) {
            commit('updateProposalAssetItem', payload)
        },
        removeProposalAssetItem({ commit }, payload) {
            commit('removeProposalAssetItem', payload)
        },
        calculateProposalAsset({ state, commit }) {
            const proposalAsset = state.asset
            calculateProposalAsset(proposalAsset)
            commit('setProposalAssetByIndex', { proposalAsset })
        },
        setProposalAssetByIndex({  state , commit }) {
            const proposalAsset = state.asset
            commit('setProposalAssetByIndex', { proposalAsset })
        },
        calculateProposalAssetItem({ state, commit }, payload) {
            const { index, proposalAssetItem } = payload
            const proposalAsset = state.asset
            calculateProposalAsset(proposalAsset)
            commit('updateProposalAssetItem', { proposalAssetItem, index })
        },
        assetCustom({ commit }, payload) {
            const { filter, callback } = payload
            getAssetCustom(filter)
                .then(res => {
                    callback(res.items);
                })
                .catch(e => logger.error(e))
        },
        
        assetTax({ commit }, payload) {
            const { callback } = payload
            getassetTax()
                .then(res => {
                    callback(res.items);
                })
                .catch(e => logger.error(e))
        },
        setOrderItemStatus({ commit }, payload) {
            commit('setOrderItemStatus', payload)
        },
        setPreConditionValid({ commit }, payload) {
            commit('setPreConditionValid', payload)
        },
        setOrderStatus({ commit }, payload) {
            commit('setOrderStatus', payload)
        },
        cleanState({ state, commit }) {
            commit('setInitial')
            this.dispatch('demandModule/cleanState')
            this.dispatch('printDocumentModule/cleanState')
            this.dispatch('orderPartyModule/cleanState')
            if(state.order.orderFinancingModule){
                this.dispatch('orderFinancingModule/cleanState')
            }
        },
        searchOrder({ commit }, payload) {
            const { filter,offset,limit, callback } = payload
            searchOrder(filter,offset,limit)
                .then(response => callback(response))
                .catch(e => logger.error(e))
        },
        changeAssetReadOnly({ commit }, payload) {
            commit('setAssetReadOnly', payload)
        },
        getOrderGatheringInfo({state, commit }, payload) {
            const { callback } = state.order.resourceUid
            getProcess(state.order.resourceUid)
                .then(response => callback(response))
                .catch(e => logger.error(e))
            commit('setOrderGatheringInfo', payload)
        },
        changePreconditionReadOnly({ commit }, payload) {
            commit('changePreconditionReadOnly', payload)
        },
        getOrderHistory({ commit }) {
            getOrderTaskHistory()
              .then((response) => {
                commit("setHistoriesStep", response);
              })
              .catch((err) => {
                logger.error(err);
                Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
                  message: err.message || err.error || err,
                  color: "negative",
                });
            });
        },
        setOrderVariablesVisible({commit}, payload) {
            commit('setOrderVariablesVisible', payload);
        },

        setOrderDetailPreconditionVisible({commit}, payload) {
            commit('setOrderDetailPreconditionVisible', payload);
        },
        setOrderDetailPrecondition({commit}, payload) {
            commit('setOrderDetailPrecondition', payload);
        },
        setOrderStatusHistoryVariablesSelected({commit}, payload) {
            commit('setOrderStatusHistoryVariablesSelected', payload);
        },
        initSelectedAssetFrom({ commit,  getters }) {
            const selectedAssetFrom = getters.getSelectedAssetFromInit
            commit('setSelectedAssetFrom', selectedAssetFrom)
        },
        initSelectedProductAsset({ commit,  getters }) {
            const slectedProductAsset = getters.getSlectedProductAssetInit
            commit('setSlectedProductAsset', slectedProductAsset)
        },
        updateTempSelectedOrderGoods({ commit }, tempSelectedOrderGoods) {
            commit('updateTempSelectedOrderGoods', tempSelectedOrderGoods);
        },
        SetSelectedSearchOrder({ commit }, payload) {
            commit('SetSelectedSearchOrder', payload);
        },
        setSlectedProductAsset({ commit }, payload) {
            commit('setSlectedProductAsset', payload);
        },
        updateInventoryItem({ commit }, payload) {
            const { inventoryItemCode, status } = payload;
               getInventoryItem(inventoryItemCode)
                .then( res => {
                      updateInventoryItem(res.data, status, inventoryItemCode)
                        .then(res => {
                            logger.debug("res ", res.data);
                        })
                        .catch(e => {
                            logger.error(e);
                        });
                })
                .catch(e => {
                    logger.error(e);
                });
        },
         getProduct({ commit }, payload) {
            const { productCode, callback} = payload
             getProductFeature(productCode)
            .then((res: any) => {
                const selectedProduct ={
                    id: res.resourceUid,
                    label: res.resourceUid,
                    config: {
                        resourceUid: res.resourceUid,
                        productUid: {
                          objectType: res.objectType,
                          systemUid: res.systemUid,
                          resourceUid: res.resourceUid
                        },
                        productName: res.name,
                        productReference: res.reference,
                        productStatus: res.status,
                        classifications: res.classifications
                      } 
                    }
                callback(selectedProduct);
            })
            .catch(e => {
                logger.error(e);
            });
               
            },
        gatheringProcessOrder: ({ commit }, payload) => {
            const { request } = payload;
            commit("setGatheringProcessOrder", request.gatheringProcess);
        },
        updateAssetDelivery({ state, commit }, payload) {
            const { value,field,index } = payload;
            if(field==='initialDeliveryDate'){
                state.orders[index].orderAssets[0].assetDelivery.initialDeliveryDate=value
                state.orders[index].initialDeliveryDate=value
                commit('setOrders', state.orders)
            }
            if(field==='effectiveDeliveryDate'){
                state.orders[index].orderAssets[0].assetDelivery.effectiveDeliveryDate=value
                state.orders[index].effectiveDeliveryDate=value
                commit('setOrders', state.orders)
            }
            if(field==='previsionDeliveryDate'){
                state.orders[index].orderAssets[0].assetDelivery.previsionDeliveryDate=value
                state.orders[index].previsionDeliveryDate=value
                commit('setOrders', state.orders)
            }
            
        },
        async setGoodProposalItemFields({ commit }, payload) {
            const { resourceUid, index, type ,callback} = payload
            const goodProposalItem = await getGoodProposalItem(resourceUid)
            if(callback){
                callback(goodProposalItem)
            }            
        },
        deleteEvent({ commit }, payload) {
            commit("deleteEvent", payload)
        },
        setOrderCommissions({ commit }, payload){
            commit("setOrderCommissions", payload)
        },
        deleteOrderCommission({ commit }, payload){
            commit("deleteOrderCommission", payload)
        },
        async selectGoodImage({ commit }, payload){
            const { productUid ,callback} = payload
            logger.debug("payload ",payload)
            const goodImage = await selectGoodImage(productUid)
            if(callback){
                callback(goodImage)
            } 
        },
        setselectedGoodImage({ state, commit }, payload) {
            const { index, goodImage} = payload
            state.orders[index].orderAssets[0].config.selectedGoodImage= goodImage
        },
        updateOrderItem({ commit }, payload) {
            const { orderItemResourceUid, previsionDeliveryDate,color } = payload;
            getOrderItem(orderItemResourceUid)
                .then( orderItem => {
                      updateOrderItem(orderItem.data, previsionDeliveryDate, orderItemResourceUid,color)
                        .then(updatedOrderItem => {
                            logger.debug("put res ", updatedOrderItem.data);
                        })
                        .catch(e => {
                            logger.error(e);
                        });
                })
                .catch(e => {
                    logger.error(e);
                });
        },
        async getOrder({ state,commit }, payload){
            const { orderResourceUid, callback } = payload;            
            
            const order = await getOrder(orderResourceUid)
        
            if(callback){
                callback(order)
            } 
        },
        createProductCategoryClass({ commit },payload) {
            const { parentResourceUid,body ,callback} = payload
            createProductCategoryClass(parentResourceUid,body)
              .then((response) => {
                callback(response);
              })
              .catch((err) => {
                logger.error(err);
                Notify.create({
timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
                  message: err.message || err.error || err,
                  color: "negative",
                });
            });
        },
        updateOrderStatus({ commit }, payload) {
            const { orderResourceUid, status } = payload;
            const orderStatus = {
                "status": status
            }
            updateOrderStatus(orderResourceUid, orderStatus)
              .then((response) => {
                logger.debug("response ", response);
                //commit()
              })
              .catch(e => {
                logger.error(e);
            });
        },
         getAlertReasons({ commit }, payload){
         
            const {callback} = payload
            getAlertReasons().then(res => {
                callback(res);
            })
            .catch(e => logger.error(e))

           
        },
        getOrderAlertList({ commit }, payload) {
            const { filter, callback } = payload
           
            getOrderAlertList(filter)
                .then(res => {
                   const alertList=  buildAlertList(res)

                    commit('setOrderAlertList',alertList)
                })
                .catch(e => logger.error(e))
        },
        
    },
    mutations: {
        setAssetReadOnly(state, payload) {
            const { readOnly } = payload
            const { asset } = state
            asset.config.readOnly = readOnly;
        },
        setOrderVariablesVisible(state, payload){
            state.variablesVisible = payload;
        },
        setOrderDetailPreconditionVisible(state, payload){
            state.preConditionDetailVisible = payload;
        },
        setOrderDetailPrecondition(state, payload){
            state.preConditionDetail = payload;
        },
        setOrderStatusHistoryVariablesSelected(state, payload){
            state.statusHistoryVariableSelected = payload;
        },
        setOrder(state, payload) {
          state.order = payload
        },
        setChannel(state, payload) {
            state.order.channel = payload
        },
        setOrderItem(state, payload) {
            state.orderItem = payload
        },
        toggleShow(state) {
            state.showAlert = !state.showAlert
        },
        setOrderAssociatedParty(state, payload){
            const {party, role, objectType} = payload
            state.order.orderParties[0].orderParty.party.resourceUid = party
            state.order.orderParties[0].orderParty.party.objectType = objectType
            state.order.orderParties[0].orderParty.role.resourceUid = role
        },

        setSupplier(state, payload){
            const { asset ,orders } = state
            const {party, objectType, role, name,orderIndex} = payload
            asset.config.formBind.supplier.party = { resourceUid: party, objectType: objectType}
            asset.config.formBind.supplier.role = { resourceUid: role }
            asset.config.formBind.supplier.name = name
            asset.config.supplierPartyName = name
            if(orderIndex !== null && orderIndex !== undefined){
                orders[orderIndex].orderAssets[0].config.formBind.supplier.party = { resourceUid: party, objectType: objectType}
                orders[orderIndex].orderAssets[0].config.formBind.supplier.role = { resourceUid: role }
                orders[orderIndex].orderAssets[0].config.formBind.supplier.name = name
                orders[orderIndex].orderAssets[0].config.supplierPartyName = name
                logger.debug(orders[orderIndex].orderAssets[0].config.supplierPartyName)
            }
        },
        setNetwork(state, payload) {
            if (state.order?.orderNetworks || state.order?.orderNetworks == "") {
                state.order.orderNetworks.network.resourceUid = payload.id
            }
        },
        setNetworkNode(state, payload) {
            if (state.order?.orderNetworkNodes || state.order?.orderNetworkNodes == "") {
                state.order.orderNetworkNodes.networkNode.resourceUid = payload.id
            }
        },
        setCommercial(state, payload) {
            if (state.order?.assignedSalesPerson || state.order?.assignedSalesPerson == "") {
                state.order.assignedSalesPerson = payload.value
            }
        },
        setPlaningEvent(state, payload) {
          state.planningDelevry=payload
            
        },
        selectedDayEvent(state, payload) {
            state.selectedDayEvent=payload   
          },

        changeDateEvent(state, payload) {
            state.selectedEventPlanning.actionStartDate =  (moment((payload)).format("DD/MM/YYYY"));
            state.selectedEventPlanning.actionStartHour=  (moment(payload).format("HH:mm"));
            state.selectedEventPlanning.actionEndDate=  (moment(payload).format("DD/MM/YYYY"));
            state.selectedEventPlanning.actionEndHour =  (moment(payload).add(2, 'hour').format("HH:mm"));
          },
        
        setInitial(state) {
            state.orders = []
            state.mode = OrderModeStatus.CREATE
            state.index = -1
            state.order = {}
            state.orderItem = {}
            delete state.asset
            state.orderFinancingModule.financing = {}
        },
        setAsset(state, payload) {
            logger.debug("setAsset")
            state.asset = payload;
        },
        setMode(state, payload) { 
            state.mode = payload
        },
        setIndex(state, payload) {
            state.index = payload
        },
        setOrders(state, payload) {
            state.orders = payload
        },
        updateProposalAssetItem(state, payload) {
            const { proposalAssetItem, index } = payload
            const proposalAsset = state.asset
            if (proposalAsset.proposalAssetItems) {
                const proposalAssetItemStateIndex = proposalAsset.proposalAssetItems.indexOf(proposalAssetItem)
                proposalAsset.proposalAssetItems[proposalAssetItemStateIndex] = proposalAssetItem
            }
        },
        removeProposalAssetItem(state, payload) {
            const { proposalAssetItem, index } = payload
            const proposalAsset = state.asset
            proposalAsset.proposalAssetItems = (proposalAsset.proposalAssetItems || []).filter((item: any) => {
                    const compareResourceUid = (!!item.resourceUid && !!proposalAssetItem.resourceUid && item.resourceUid === proposalAssetItem.resourceUid)
                    const compareReference = (item.config.reference && proposalAssetItem.config.reference && item.config.reference === proposalAssetItem.config.reference)
                    const isRemoved = compareResourceUid || compareReference
                    return !isRemoved
                }
            )
        },
        setProposalAssetByIndex(state, payload) {
            const { proposalAsset } = payload
            state.asset = proposalAsset;
        },
       
        setOrderItemStatus(state, payload) {
            state.orderItem.status.resourceUid = payload
        },
        setPreConditionValid(state, payload) {
            state.preConditionValid = payload
        },
        setOrderStatus(state, payload) {
            state.order.status.resourceUid = payload
        },
        setOrderAlertList(state, payload) {
            state.alertList = payload
        },
        setOrderGatheringInfo(state, payload) {
            state.order.status.resourceUid = payload
        },
        setHistoriesStep(state, payload) {
            state.historiesStep = payload
        },
        setSelectedAssetFrom(state, payload) {
            state.selectedAssetFrom = payload
        },
        setSlectedProductAsset(state, payload) {
            state.selectedProductAsset = payload
        },
        updateTempSelectedOrderGoods(state, payload) {
            state.tempSelectedOrderGoods = payload;
        },
        setGatheringProcessOrder(state, payload) {
            state.gatheringProcessOrder = payload;
        },
        setAssetDeliveryModel(state, payload) {
            state.assetDeliveryModel = payload;
        },
        deleteEvent(state, payload) {
            const { index } = payload
            state.planningDelevry?.splice(index-1, 1);
        },
        setAlertList(state, payload) {
            state.order.alertList = payload;
          },
        setorderSubvention(state, payload) {
            state.order.orderSubvention = payload;
          },
        SetSelectedSearchOrder(state, payload) {
            state.selectedSearchOrder = payload;
        },
        setSelectedEventPlanning(state, payload) {
            state.selectedEventPlanning = payload;
        },
        setOrderCommissions(state, payload) {
            state.order.orderCommissions = payload;
        },
        deleteOrderCommission(state, payload) {
            const { index } = payload
             if (index !== -1) {
                state.order.orderCommissions.splice(index, 1);
            }
        }
        
    },
    modules: {
        orderFinancingModule: orderFinancingModule,
    },
}

export default orderModule;
